import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assertAndContinue} from 'Asserts';
import * as Colors from 'ui-library/Colors';

const styles = StyleSheet.create({
  headerText: {
    minHeight: 30,
    paddingTop: 8,
    paddingLeft: 8,
    marginTop: -5,
    marginBottom: -5,
    marginLeft: -8,
    marginRight: -8,
    backgroundColor: Colors.GRAY_LIGHTER,
  },
});

export const SHOW_UNIT_OPS_AND_MULTIEXPERIMENT_ENABLED_PARAMS_TABLE_COLS = [
  <col key="unit operation" width="15%" />,
  <col key="param name" width="15%" />,
  <col key="description" width="27%" />,
  <col key="replicate" width="8%" />,
  <col key="Created" width="13%" />,
  <col key="status" width="10%" />,
  <col key="worksheet" width="20%" />,
];

export const SHOW_UNIT_OPS_PARAMS_TABLE_COLS = [
  <col key="unit operation" width="15%" />,
  <col key="param name" width="15%" />,
  <col key="description" width="27%" />,
  <col key="replicate" width="10%" />,
  <col key="status" width="13%" />,
  <col key="worksheet" width="20%" />,
];

export const MULTIEXPERIMENT_ENABLED_PARAMS_TABLE_COLS = [
  <col key="param name" width="20%" />,
  <col key="description" width="30%" />,
  <col key="replicate" width="8%" />,
  <col key="Created" width="14%" />,
  <col key="status" width="10%" />,
  <col key="worksheet" width="20%" />,
];

export const SHOW_UNIT_OPS_AND_MULTIEXPERIMENT_ENABLED_PARAMS_TABLE_HEADER_CELLS = [
  <div className={css(styles.headerText)}>Unit operation</div>,
  <div className={css(styles.headerText)}>Run name</div>,
  <div className={css(styles.headerText)}>Description</div>,
  <div className={css(styles.headerText)}>Replicate</div>,
  <div className={css(styles.headerText)}>Created</div>,
  <div className={css(styles.headerText)}>Status</div>,
  <div className={css(styles.headerText)}>Worksheet</div>,
];

export const MULTIEXPERIMENT_ENABLED_PARAMS_TABLE_HEADER_CELLS = [
  <div className={css(styles.headerText)}>Run name</div>,
  <div className={css(styles.headerText)}>Description</div>,
  <div className={css(styles.headerText)}>Replicate</div>,
  <div className={css(styles.headerText)}>Created</div>,
  <div className={css(styles.headerText)}>Status</div>,
  <div className={css(styles.headerText)}>Worksheet</div>,
];

export const SHOW_UNIT_OPS_PARAMS_TABLE_HEADER_CELLS = [
  <div className={css(styles.headerText)}>Unit operation</div>,
  <div className={css(styles.headerText)}>Condition</div>,
  <div className={css(styles.headerText)}>Description</div>,
  <div className={css(styles.headerText)}>Replicate</div>,
  <div className={css(styles.headerText)}>Status</div>,
  <div className={css(styles.headerText)}>Worksheet</div>,
];

export function getProcedureRunParamsTableColumnsAndHeaderCells(
  isMultiExperimentEnabled: boolean,
  showUnitOpsColumn: boolean
): Array<Array<JSX.Element>> {
  if (showUnitOpsColumn && isMultiExperimentEnabled) {
    return [
      SHOW_UNIT_OPS_AND_MULTIEXPERIMENT_ENABLED_PARAMS_TABLE_COLS,
      SHOW_UNIT_OPS_AND_MULTIEXPERIMENT_ENABLED_PARAMS_TABLE_HEADER_CELLS,
    ];
  } else if (showUnitOpsColumn) {
    return [SHOW_UNIT_OPS_PARAMS_TABLE_COLS, SHOW_UNIT_OPS_PARAMS_TABLE_HEADER_CELLS];
  } else {
    assertAndContinue(
      showUnitOpsColumn || isMultiExperimentEnabled,
      'Unit ops column cannot be hidden when multiple experiments are disabled'
    );
    return [MULTIEXPERIMENT_ENABLED_PARAMS_TABLE_COLS, MULTIEXPERIMENT_ENABLED_PARAMS_TABLE_HEADER_CELLS];
  }
}
